<template>
  <x-page title="退款结果" :loading="loading">
    <div :class="_.page">
      <img :src="require('./images/退款成功.png')" :class="_.icon" />
      <div
        :class="_.message"
        @click="handleMessageClick"
        v-html="refundData.text"
      />
      <x-button
        v-if="prevPageIsOrderList"
        v-track="{
          name: '回到首页',
          id: '5ffb9549-7ac1-44bb-a895-a24bcee12764',
        }"
        inline
        small
        :class="_.button"
        @click="handleBackClick"
      >
        回到首页
      </x-button>
      <x-button
        v-else
        v-track="{
          name: '自动退款-查看详情',
          id: '2816cc07-4a4b-4ce2-8246-a72b6ad6c229',
        }"
        inline
        small
        :class="_.button"
        @click="handleBackClick"
      >
        查看详情
      </x-button>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiBlindBoxOrderGetRefundAmount } from '@/api'
  import { copyTextToClipboard } from 'vtils'
  import { mapQuery, prepareData, Track } from '@/utils'
  import { navigateTo, prevPageIs } from '@/router'
  import { Toast } from 'vant'

  export default Vue.extend({
    mixins: [
      mapQuery({
        orderId: 'orderId',
      }),
      Track.provideMark(() => ({
        page: '多多盲盒退款结果页',
      })),
    ],

    data: () => ({
      loading: true,
      refundData: {},
      prevPageIsOrderList: prevPageIs('BoxOrderList'),
    }),

    created() {
      this.prepareData()
    },

    methods: {
      async prepareData() {
        const { refundData } = await prepareData({
          refundData: apiBlindBoxOrderGetRefundAmount({
            id: this.orderId,
          }),
        })
        this.refundData = refundData
        this.loading = false
      },

      handleBackClick() {
        if (this.prevPageIsOrderList) {
          navigateTo('BoxIndex', {
            id: this.refundData.activityId,
          })
        } else {
          navigateTo('BoxOrderList', {
            active: 4,
          })
        }
      },

      /**
       * @param e {{target: HTMLDivElement}}
       */
      handleMessageClick(e) {
        if (e?.target?.classList.contains('can-copy')) {
          copyTextToClipboard(e.target.innerText.trim())
          Toast.success('复制成功')
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 38px;

    .icon {
      margin-top: 64px;
      width: 55px;
      height: 55px;
    }

    .message {
      margin-top: 23px;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: center;

      span {
        color: #ff111c;
      }

      :global(.can-copy) {
        font-weight: var(--bold-value);
      }
    }

    .button {
      margin-top: 32px;
    }
  }
</style>
